import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";

export function NotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={{ py: 8, textAlign: "center" }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Page not found
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        We couldn’t find that page. It may have moved or never existed.
      </Typography>
      <Button
        onClick={() => navigate("/", { replace: true })}
        variant="contained"
        sx={{ bgcolor: "#004f77", "&:hover": { bgcolor: "#0a6a9e" } }}
      >
        Back to courses
      </Button>
    </Box>
  );
}

export default NotFound;
